const DICEBEAR_VERSION = "10.x";
const DEFAULT_STYLE = "initials";

const DEFAULT_BACKGROUND_COLORS = ["4E4E98", "3DB582", "38D9C8"];

export function getAvatarUrl(seed, options = {}) {
  if (!seed) return "";

  const { style = DEFAULT_STYLE, backgroundColor = DEFAULT_BACKGROUND_COLORS, params = {} } = options;

  const query = new URLSearchParams({
    seed: String(seed),
    backgroundColor: backgroundColor.join(","),
    ...params,
  });

  return `https://api.dicebear.com/${DICEBEAR_VERSION}/${style}/svg?${query.toString()}`;
}

export const AVATAR_COLOR_TOKENS = ["accent", "danger", "success", "warning", "success"];
 
export function getColorForId(id) {
  if (!id) return AVATAR_COLOR_TOKENS[0];
 
  const str = String(id);
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = (hash << 5) - hash + str.charCodeAt(i);
    hash |= 0;
  }
 
  return AVATAR_COLOR_TOKENS[Math.abs(hash) % AVATAR_COLOR_TOKENS.length];
}